<template>
  <main>
    <NuxtLayout :name="layout">
      <NuxtPage />
    </NuxtLayout>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import useBrand from './utils/useBrand';
import requestInterceptor from './utils/interceptors/PersistentLoginRequestInterceptor';
import sessionTimeOutHandler from './utils/interceptors/SessionTimeOutHandler';
import { headLinks } from '~/utils/headLinks';

const { isBcom } = useBrand();

useHead({
  title: "My Account - My Wallet - Macy's",
  link: headLinks,
});

onBeforeMount(() => {
  requestInterceptor();
  sessionTimeOutHandler();
});

const layout = computed(() => (isBcom ? 'app-bcom' : 'app-mcom'));
</script>
